<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_vii"><span class="txit">To all of my family past and present, on my American and Zimbabwean sides—the farmers, public servants, military, teachers, and writers, stretching back generation after generation—who worked hard and led me to my own path.</span></a><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4aa1b5cd